import React, { useState } from "react";
import ProgressBar from "./Progressbar";
import Loader from "../../elements/Loader";
import ETskills from "./ETskills";
import ETProfile from "./ETProfile";
import CCDetails from "./CCDetails";
import ETComments from "./ETComments";
import styles from '../checkout/progressbar.module.scss';

function ProgressBarData(props) {
    console.log(props.globalData);
    const [loading, setLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const totalSteps = 4;

    const handleNext = (skilldata) => {
        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
        }
        if(currentStep==1){
        localStorage.setItem('skilldata',JSON.stringify(skilldata))
        }
    };

    const handlePrevious = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    return (
        <div>
            {loading ? (
                <div className="loaderContainer">
                    <div className="loader">
                        <Loader />
                    </div>
                </div>
            ) : (
                <>
                    <ProgressBar currentStep={currentStep} totalSteps={totalSteps} onNext={handleNext} onPrevious={handlePrevious} />
                    {currentStep === 1 && <ETskills onNext={handleNext} />}
                    {currentStep === 2 && (
                        <ETProfile onNext={handleNext} onPrevious={handlePrevious} leadPlatform={props.globalData.lead_platform_main_component[0]}  cluster={props.globalData.cluster_main_component[0]}/>
                    )}
                    {currentStep === 3 && (
                        <CCDetails onNext={handleNext} onPrevious={handlePrevious} />
                    )}
                    {currentStep === 4 && (
                        <ETComments onNext={handleNext} onPrevious={handlePrevious} />
                    )}
                    <div className={styles.buttoncontainer}>
                        {currentStep > 1 && (
                            <button className={styles.previousbutton} onClick={handlePrevious}>
                            </button>
                        )}
                        {currentStep < totalSteps && (
                            <button className={styles.nextbutton} onClick={handleNext}>
                            </button>
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default ProgressBarData;
